import { render, staticRenderFns } from "./SecuriteParcours.vue?vue&type=template&id=3b93c25e&scoped=true&"
import script from "./SecuriteParcours.vue?vue&type=script&lang=js&"
export * from "./SecuriteParcours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b93c25e",
  null
  
)

export default component.exports